import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Terms: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={() => navigate(-1)} 
                    sx={{ mb: 3 }}
                >
                    Back
                </Button>
                
                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                    Terms and Conditions
                </Typography>
                
                <Typography variant="body1" paragraph>
                    Welcome to our Terms and Conditions page. Please read these terms and conditions carefully before using our service.
                </Typography>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        1. Introduction
                    </Typography>
                    <Typography variant="body1" paragraph>
                        These terms and conditions govern your use of our website and services. By using our website, you accept these terms and conditions in full.
                    </Typography>
                </Box>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        2. Intellectual Property Rights
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Unless otherwise stated, we or our licensors own the intellectual property rights in the website and material on the website. All these intellectual property rights are reserved.
                    </Typography>
                </Box>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        3. License to Use Website
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
                    </Typography>
                </Box>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        4. Acceptable Use
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You must not use our website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website.
                    </Typography>
                </Box>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        5. Restricted Access
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Access to certain areas of our website is restricted. We reserve the right to restrict access to other areas of our website, or indeed our whole website, at our discretion.
                    </Typography>
                </Box>
                
                <Box sx={{ mt: 5, textAlign: 'center' }}>
                    <Button variant="contained" onClick={() => navigate('/')} sx={{ mx: 1 }}>
                        Back to Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default Terms;